import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { coolGrey1 } from 'approot/shared/styles/colours.style';

export const PlayerOuter = styled.div`
  border-radius: ${rem(borderRadius8)};
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const PlayerInner = styled.div`
  background-color: ${coolGrey1};
  padding-top: 56.25%;
  position: relative;

  iframe {
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
  }
`;
